import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelModule } from 'primeng/panel';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

import { DomainMultipleSelectorComponent } from '../../domain-multiple-selector/domain-multiple-selector.component';
import {
  BillingService,
  TrunkingSummaryRow,
} from '../../../services/billing.service';
import { TrunkingSummaryTourService } from './trunking-summary-tour.service';
import { NotificationsService } from '../../../services/notifications.service';
import { NetsapiensDomain } from '@voice/utils';
import { saveAs } from 'file-saver';

type TrunkingDomainData = {
  domain: string;
  row?: TrunkingSummaryRow;
};

@Component({
  selector: 'app-trunking-summary',
  standalone: true,
  imports: [
    CommonModule,
    PanelModule,
    ButtonModule,
    TooltipModule,
    DomainMultipleSelectorComponent,
  ],
  templateUrl: './trunking-summary.component.html',
  styleUrls: ['./trunking-summary.component.css'],
})
export class TrunkingSummaryComponent implements OnInit {
  private readonly tourService = inject(TrunkingSummaryTourService);

  collapsed = false;
  requesting = false;
  domainSummaries?: TrunkingDomainData[];

  domainsList: Partial<NetsapiensDomain>[] = [];
  selectedDomains?: string[];

  constructor(
    private readonly billing: BillingService,
    private readonly notifications: NotificationsService
  ) {}

  startTour(): void {
    this.tourService.start();
  }

  ngOnInit(): void {
    const includeAdminAndDemo = false;
    this.billing.getTrunkingDomains(includeAdminAndDemo).subscribe({
      next: (res) => {
        this.domainsList = res.domains;
      },
      error: (err) => this.notifications.error(err),
    });
  }

  process(domains: string[] | null): void {
    if (!domains) {
      this.domainSummaries = undefined;
      this.selectedDomains = undefined;
      this.collapsed = false;
      return;
    }

    this.requesting = true;
    this.selectedDomains = domains;

    this.billing.getTrunkingSummary(domains).subscribe({
      next: (rows) => {
        const byDomain = new Map<string, TrunkingSummaryRow>();
        rows.forEach((r) => byDomain.set(r.DOMAIN, r));

        this.domainSummaries = domains.map((d) => ({
          domain: d,
          row: byDomain.get(d),
        }));

        this.requesting = false;
        this.collapsed = true;
      },
      error: (err) => {
        this.notifications.error(err);
        this.requesting = false;
      },
    });
  }

  download(): void {
    if (!this.selectedDomains?.length) {
      this.notifications.info('No domains selected.');
      return;
    }

    this.requesting = true;
    this.billing.getTrunkingSummaryCsv(this.selectedDomains).subscribe({
      next: (blob) => {
        saveAs(blob, 'trunking-summary.csv');
        this.notifications
          .success('File saved. Please, check your downloads folder')
        this.requesting = false;
      },
      error: (err) => {
        this.notifications.error(err);
        this.requesting = false;
      },
    });
  }
}
